module.exports = __webpack_public_path__ + "static/media/bu_hraswo.40e3732f.ogg";